<template>
  <div class="container">
    <loading v-model:active="loading" />
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-xs">
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >

                <div
                  class="modal-body mdScroll px-lg-5 pb-lg-4 px-md-5 pb-md-5 px-3 pb-3"
                >
                  <h4 class="tm5 modal-title d-inline-block">
                    My {{ this.itemName }}s
                  </h4>
                  <div class="itemsInner scrollbar" v-if="info.length">
                    <div class="energy-wrapper flex-wrap">
                      <template v-for="(item, index) in info" :key="index">
                        <div class="energy-content mb-4" v-if="item.value > 0">
                          <div class="img-frame">
                            <img
                              :class="
                                item.key == '1,RESIN' || item.key == '1,JERKY'
                                  ? 'resin-img'
                                  : ''
                              "
                              :src="`/images/gameitem/${
                                item.key.split(',')[1]
                              }.png`"
                              alt=""
                            />
                          </div>
                          <p class="text-success">({{ item.value }})</p>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="energy-wrapper" v-else>
                    <p>
                      You don't have any item, <a href="/market">Shop here</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
export default {
  name: "gameItems",
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["gameItems"]),
  },
  props: ["error", "showModel", "items", "itemName"],
  showModal: true,
  data() {
    return {
      loading: false,
      info: [],
    };
  },
  mounted() {
    let food = ["1,BEANS", "1,CBREAD", "1,JERKY", "1,FSTEW"];
    if (this.itemName == "food")
      this.info = this.gameItems.filter((row) => food.includes(row.key));
    else this.info = this.gameItems.filter((row) => !food.includes(row.key));
    console.log(this.info);
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
  },
};
</script>
  
  <style scoped>
.energy-wrapper .resin-img {
  padding: 20px;
}
.modal-wrapper .modal-content {
  padding: 5px 0px;
  height: auto;
}
.energy-wrapper {
  display: flex;
  justify-content: center;
}
.energy-content {
  width: 30%;
}
.energy-content img {
  width: 100%;
  aspect-ratio: 1/2;
  -o-object-fit: contain;
  object-fit: contain;
  height: 100%;
  padding: 8px;
}
.energy-content p {
  color: var(--mainWhite);
  margin-bottom: 0;
}
.itemsInner {
  height: 300px;
  overflow: auto;
}
@media (max-width: 768px) {
  .energy-content {
    width: 50%;
  }
  .modal-wrapper .modal-content {
    height: 380px;
  }
}
</style>
  